// Copyright Prashant Vaghela, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import { Theme } from '@cloudscape-design/components/theming';

export const customTheme: Theme = {
  tokens: {
    // Values are applied globally, except for visual contexts
    colorBackgroundLayoutMain: {
      light: '#F3F3F3',
      dark: 'black',
    },
    // Shorter syntax to apply the same value for both light and dark mode
    colorTextAccent: '#0073bb',
    fontFamilyBase: "'Helvetica Neue', Roboto, Arial, sans-serif",
    borderRadiusButton: '0',
    borderRadiusContainer: '0',
    borderRadiusDropdown: '0',
    borderRadiusFlashbar: '0',
    borderRadiusPopover: '0',
    borderRadiusItem: '0',
    borderRadiusInput: '0',
  },
  contexts: {
    // Values for visual contexts. Unless specified, default values will be applied
    alert: {
      tokens: {},
    },
    header: {
      tokens: {},
    },
  },
};
